import { Box, DropdownV5, Text, Colors } from '@pinchenterprisesnpm/friday-ui'
import {
  amountLiftedFrequentlyDropdownData,
  amountLiftedOccasionallyDropdownData,
  amountOfTimeSpentOnFeetDropdownData,
} from 'helpers/physicalRequirementsUtils'
import { IDropdownData, TypeOrNull } from '@src/models/Common'

interface IPhysicalRequirementsProps {
  amountLiftedFrequently: TypeOrNull<IDropdownData>
  amountLiftedOccasionally: TypeOrNull<IDropdownData>
  amountOfTimeSpentOnFeet: TypeOrNull<IDropdownData>
  updatePhysicalRequirements: (field: string, value: IDropdownData) => void
  physicalReqsErrors: {
    amountOfTimeSpentOnFeet?: string
    amountLiftedFrequently?: string
    amountLiftedOccasionally?: string
  }
}

export const PhysicalRequirements = ({
  amountLiftedFrequently,
  amountLiftedOccasionally,
  amountOfTimeSpentOnFeet,
  updatePhysicalRequirements,
  physicalReqsErrors,
}: IPhysicalRequirementsProps) => {
  const isAmountLiftedOccasionallyFieldDisabled =
    amountLiftedFrequently?.value === amountLiftedFrequentlyDropdownData[0].value

  return (
    <Box mb='md'>
      <Text fontSize='medium' fontWeight='bold' mb='xs'>
        Physical Requirements
      </Text>

      <Box>
        <Text fontSize='medium' mb='xs'>
          Amount Lifted Frequently *
        </Text>

        <DropdownV5
          value={amountLiftedFrequently}
          options={amountLiftedFrequentlyDropdownData}
          onChange={(value: IDropdownData) =>
            updatePhysicalRequirements('amountLiftedFrequently', value)
          }
          size='large'
          type='primary'
          rounded={true}
          isOutlined
          borderColor={Colors.border}
          errorMessage={physicalReqsErrors.amountLiftedFrequently}
          menuPlacement='top'
        />
      </Box>

      <Box>
        <Text fontSize='medium' mb='xs'>
          Amount Lifted Occasionally *
        </Text>

        <DropdownV5
          value={amountLiftedOccasionally}
          options={amountLiftedOccasionallyDropdownData}
          onChange={(value: IDropdownData) =>
            updatePhysicalRequirements('amountLiftedOccasionally', value)
          }
          size='large'
          type='primary'
          rounded={true}
          isOutlined
          isDisabled={isAmountLiftedOccasionallyFieldDisabled}
          borderColor={Colors.border}
          errorMessage={physicalReqsErrors.amountLiftedOccasionally}
          menuPlacement='top'
        />
      </Box>

      <Box>
        <Text fontSize='medium' mb='xs'>
          Amount of Time Spent on Feet *
        </Text>

        <DropdownV5
          value={amountOfTimeSpentOnFeet}
          options={amountOfTimeSpentOnFeetDropdownData}
          onChange={(value: IDropdownData) =>
            updatePhysicalRequirements('amountOfTimeSpentOnFeet', value)
          }
          size='large'
          type='primary'
          rounded={true}
          isOutlined
          borderColor={Colors.border}
          errorMessage={physicalReqsErrors.amountOfTimeSpentOnFeet}
          menuPlacement='top'
        />
      </Box>
    </Box>
  )
}
